import { version } from '../../package.json';

// The build's identity on its own (no report code): the start screen shows it without loading the report.
export const APP_VERSION: string = version;
/** This build (src/build/buildId.ts): changes on every deploy. */
export const BUILD_ID: string = __BUILD_ID__;
/** The part after the `+`: "20261010-2105-90e5e1c". */
export const BUILD: string = BUILD_ID.slice(BUILD_ID.indexOf('+') + 1);
/** Where testers send reports, and the app's contact address (pages). */
export const REPORT_EMAIL = 'magialiapp@gmail.com';
